import { createApp } from 'vue'
import App from './App.vue'
import "@/assets/scss/Global.scss"
import router from './router'
import i18n from './i18n'
import { vueAxios } from '@/plugins/axios'
import { vueKeycloak } from '@/plugins/keycloak'
import VueGoogleMaps from '@fawmi/vue-google-maps'
import { createPinia } from 'pinia'

import { IsLoggedIn } from '@/services/IsLoggedIn';
import { PriceClean } from '@/services/PriceClean';
import { LabelInput } from '@/services/LabelInput';
import { KitStyle } from '@/services/KitStyle';
import { IsMobile } from '@/services/IsMobile';
import { UpdateCart } from '@/services/UpdateCart';
import { OrderDraft } from '@/services/OrderDraft';
import { Logout } from '@/services/Logout';
import { ctrlPermissions } from '@/services/Permissions';

import directives from "@/directives/";

const pinia = createPinia();

const app = createApp(App).use(i18n).use(vueKeycloak, {
    initOptions: {
        flow: 'implicit', // default
        checkLoginIframe: false, // default
        onLoad: 'check-sso', //'check-sso', // 'login-required'
        // silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html',
        redirectUri: window.location.origin + '/',
        "always-refresh-token": true
    },
    config: {
        url: window.VUE_APP_KEYCLOAK_URL,
        realm: window.VUE_APP_KEYCLOAK_REALM,
        clientId: window.VUE_APP_KEYCLOAK_CLIENT_ID
    }
}).use(VueGoogleMaps, {
    load: {
        key: window.VUE_APP_GOOGLE_KEY,
        libraries: "places"
        // language: 'it',
    },
}).use(router).use(vueAxios).use(pinia);

app.config.globalProperties.$IsLoggedIn = IsLoggedIn;
app.config.globalProperties.$PriceClean = PriceClean;
// app.config.globalProperties.$SetNavigator = SetNavigator;
app.config.globalProperties.$LabelInput = LabelInput;
app.config.globalProperties.$KitStyle = KitStyle;
app.config.globalProperties.$IsMobile = IsMobile;
app.config.globalProperties.$UpdateCart = UpdateCart;
app.config.globalProperties.$OrderDraft = OrderDraft;
app.config.globalProperties.$Logout = Logout;
app.config.globalProperties.$ctrlPermissions = ctrlPermissions;

// app.loadScript("https://code.getmdl.io/1.3.0/material.min.js");

directives(app);

app.mount('#app');
